<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
